import { PromotionRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { Promotion } from "@utilities/types";

export interface ProductWithPromotion {
    product: any;
    originalPrice: number;
    discountedPrice: number | null;
    promotion: Partial<Promotion> | null;
    discountPercent: number | null;
}

export interface CampaignsResponse {
    all: Promotion[];
    active: Promotion[];
    scheduled: Promotion[];
    expired: Promotion[];
    total: number;
}

export const promotionService = {

    getAllOrganisationPromotions: async (organisationID: string) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_GET_ALL_ORGANISATION_PROMOTIONS}/${organisationID}`,
            method: "GET",
        });
    },

    getOnePromotion: async (organisationID: string, promoCode: string) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_GET_ONE}?organisationID=${organisationID}&promoCode=${promoCode}`,
            method: "GET",
        });
    },

    createPromotion: async (promotionData: Partial<Promotion>) => {
        return await fetchRequest({
            route: PromotionRoutesEnum.PROMOTION_CREATE,
            method: "POST",
            data: promotionData,
        });
    },

    updatePromotion: async (promotionID: string, promotionData: Partial<Promotion>) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_UPDATE}/${promotionID}`,
            method: "PUT",
            data: promotionData,
        });
    },

    addPromotionToCategory: async (categoryID: string, promotionID: string) => {
        return await fetchRequest({
            route: PromotionRoutesEnum.PROMOTION_ADD_TO_CATEGORY,
            method: "PUT",
            data: { categoryID, promotionID },
        });
    },

    addPromotionToProduct: async (productID: string, promotionID: string) => {
        return await fetchRequest({
            route: PromotionRoutesEnum.PROMOTION_ADD_TO_PRODUCT,
            method: "PUT",
            data: { productID, promotionID },
        });
    },

    deletePromotion: async (promotionID: string) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_DELETE}/${promotionID}`,
            method: "DELETE",
        });
    },

    deletePromotionFromCategory: async (categoryID: string) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_DELETE_FROM_CATEGORY}`,
            method: "DELETE",
            data: { categoryID },
        });
    },

    deletePromotionFromProduct: async (productID: string) => {
        return await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_DELETE_FROM_PRODUCT}`,
            method: "DELETE",
            data: { productID },
        });
    },

    // Nouvelles méthodes pour les campagnes
    getProductsWithPromotion: async (organisationID: string, page?: number, limit?: number, categoryID?: string) => {
        let route = `${PromotionRoutesEnum.PROMOTION_GET_PRODUCTS_WITH_PROMO}/${organisationID}?page=${page || 1}&limit=${limit || 10}`;
        if (categoryID) {
            route += `&categoryID=${categoryID}`;
        }
        return await fetchRequest({
            route,
            method: "GET",
        });
    },

    getAllCampaigns: async (organisationID: string) => {
        const response = await fetchRequest({
            route: `${PromotionRoutesEnum.PROMOTION_GET_ALL_CAMPAIGNS}/${organisationID}`,
            method: "GET",
        });
        return response.data as CampaignsResponse;
    },

};
